<header nx-header>
    <nx-header-row [ngClass]="{'background-header-prod': isProduction === true, 'background-header-test': isProduction === false}">
        <nx-header-brand class="nx-margin-right-5xl">
            <nx-link>
                <a href="/dashboard">
                    <figure nxFigure><img src="assets/eakte_plus_logo.png" alt="eAkte Plus Logo" role="none" style="height: 55px;"></figure>
                </a>
            </nx-link>
            <nx-header-app-title>EncoresPlus eAkte Portal</nx-header-app-title>
        </nx-header-brand>
        <nx-header-actions>
            
            <button *ngIf="!isLoggedIn()" nxButton="secondary small" type="button" (click)="logIn()"  (contextmenu)="sendReports()">
                Login
            </button>
            <button *ngIf="isLoggedIn()" nxButton="secondary small" type="button" (click)="logout()" (contextmenu)="sendReports()">
                Logout
            </button>
        </nx-header-actions>
    </nx-header-row>
</header>

<app-session-timer></app-session-timer>
<router-outlet></router-outlet>
